module.exports = __webpack_public_path__ + "static/media/WhiteMagical.b6418ede.jpg";